import React from 'react';
import PropTypes from 'prop-types';
import ProductModalDetails from './ProductModalDetails';
import ProductModalPermissions from './ProductModalPermissions';
import ProductModalSales from './ProductModalSales';
import ProductModalEngagement from './ProductModalEngagement';
import ProductModalDrips from './ProductModalDrips';
import TabGroup from './ui/TabGroup';


class ProductModal extends React.Component{

    state = {
        product: {...this.props.product},
        currentTab: 'Details'
    };

    changeTab = (tab) => {
        this.setState({ currentTab: tab });
    };

    updateProduct = (key, value) => {
        const product = {...this.state.product};
        product[key] = String(value);
        this.setState({product});
    };

    saveProduct = (e) => {
        e.preventDefault();
        const product = this.state.product;
        if(!!product.filtered){
            product.filtered = null;
        }
        this.props.updateProduct(product, this.props.productKey);
    };

    addRepeatItem = (itemName) => {
        const product = {...this.state.product};
        const timestamp = Date.now();
        if(!product[itemName]) {
            product[itemName] = {};
        }
        product[itemName][timestamp] = {};
        this.setState({product});
    };

    removeRepeatItem = (itemName, id) => {
        const product = {...this.state.product};
        product[itemName][id] = null;
        this.setState({product});
    };

    updateRepeatItem = (itemName, id, item) => {
        const product = {...this.state.product};
        if(!product[itemName][id]) {
            product[itemName][id] = {};
        }
        product[itemName][id] = {'catName': item.keyName, 'catTags': item.value};
        this.setState({product});
    };

    renderTitle = () => {
        if(this.props.newProduct) {
            return 'Add product';
        } else {
            return 'Edit product';
        }
    };

    renderTabPanels = () => {
        switch(this.state.currentTab) {
            case 'Details': 
                return <ProductModalDetails product={this.state.product} updateProduct={this.updateProduct} />
            case 'Permissions':
                return <ProductModalPermissions product={this.state.product} updateProduct={this.updateProduct} />
            case 'Engagement':
                return <ProductModalEngagement product={this.state.product} updateProduct={this.updateProduct} />
            case 'Drip':
                return <ProductModalDrips product={this.state.product} addDrip={this.addRepeatItem} updateDrip={this.updateRepeatItem} removeDrip={this.removeRepeatItem} />
            case 'Sales':
                return <ProductModalSales product={this.state.product} updateProduct={this.updateProduct} addPreview={this.addRepeatItem} updatePreview={this.updateRepeatItem} removePreview={this.removeRepeatItem} />
            default:
                return null;
        }
    };

    render() {
        return (
            <div className="modal" role="dialog" onClick={this.props.closeProductModal}>
                <div className="modal-dialog modal-lg" role="document" onClick={(e) => {e.stopPropagation()}}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{this.renderTitle()}</h5>
                            <button type="button" className="close" onClick={this.props.closeProductModal}>
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <form ref={(input) => this.form = input} onSubmit={(e) => {this.saveProduct(e)}}>
                            <div className="modal-body">
                                <TabGroup tabs={['Details', 'Permissions', 'Engagement', 'Drip', 'Sales']} currentTab={this.state.currentTab} onChange={this.changeTab} />
                                
                                {this.renderTabPanels()}
                            </div>
                            <div className="modal-footer flex-between">
                                {this.props.newProduct ? <div /> : <button type="button" className="btn btn-primary btn-with-icon btn-delete" onClick={e => this.props.deleteProduct(this.props.productKey)}><i className="material-icons">delete</i>Delete</button>}
                                
                                <div>
                                    <button type="button" className="btn btn-secondary btn-with-icon" onClick={this.props.closeProductModal}><i className="material-icons">cancel</i>Cancel</button>
                                    <button type="submit" className="btn btn-primary btn-with-icon"><i className="material-icons">save</i>Save</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

ProductModal.propTypes ={
    product: PropTypes.object.isRequired,
    productKey: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    closeProductModal: PropTypes.func.isRequired,
    deleteProduct: PropTypes.func.isRequired,
    updateProduct: PropTypes.func.isRequired,
    newProduct: PropTypes.bool.isRequired
}

export default ProductModal;


/** WEBPACK FOOTER **
 ** ./src/components/ProductModal.js
 **/